import { deepCopy } from "../../../../utils/deepCopy";
import { toast } from "../../../../utils/messageUtils";

export const fetchDirectReporteeHeatmapQuestionsStarted = (state) => {
    return {
        ...state,
        directReporteeHeatmapQuestionsApi: {
            isProcessing: true,
            error: false
        }
    }

}

export const fetchDirectReporteeHeatmapQuestionsSuccess = (state, payload) => {
    let topicQuestions = [];
    let heatmapData = deepCopy(state.directReporteeHeatmapData);
    if (payload.data && payload.data.data) {
        topicQuestions = payload.data.data.dataMap
    }
    if (topicQuestions.length) {
        heatmapData = addTopicQuestionsToTopic({ heatmapData, topicQuestions }, payload.dimension)
    }
    return {
        ...state,
        directReporteeHeatmapQuestionsApi: {
            isProcessing: false,
            error: false
        },
        directReporteeHeatmapData: heatmapData
    }

}

export const fetchDirectReporteeHeatmapQuestionsFailed = (state, payload) => {
    toast.error("Failed to fetch questions data.")
    return {
        ...state,
        directReporteeHeatmapQuestionsApi: {
            isProcessing: false,
            error: true
        },
        isDataFetchedDirectReportee: false
    }

}

const addTopicQuestionsToTopic = ({ heatmapData, topicQuestions }, dimension) => {
    const data = heatmapData;
    data.forEach(item => {
        if (item.name === dimension) {
            item.children = topicQuestions
        }
    })
    return data
}